// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__5OsAi","checkboxCol":"Table_checkboxCol__1MspB","emailCol":"Table_emailCol__1jyEE","actionCol":"Table_actionCol__1Fo3y"};